import axios from 'axios'

export const REST_ENDPOINT = process.env.VUE_APP_REST_HTTP || 'http://localhost:8002/api/lenkila'

export default axios.create({
    baseURL: REST_ENDPOINT,
    withCredentials: true,
})
